var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReferralicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 15V16.5H5.6895L1.5 20.6895L2.5605 21.75L6.75 17.5605V20.25H8.25V15H3ZM14.25 7.5H19.5V9H14.25V7.5ZM14.25 11.25H19.5V12.75H14.25V11.25ZM14.25 15H19.5V16.5H14.25V15Z",
    fill: "#101010"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 3.75H3C2.6023 3.7504 2.221 3.90856 1.93978 4.18978C1.65856 4.471 1.5004 4.8523 1.5 5.25V12.75H3V5.25H11.25V20.25H21C21.3977 20.2496 21.779 20.0914 22.0602 19.8102C22.3414 19.529 22.4996 19.1477 22.5 18.75V5.25C22.4996 4.8523 22.3414 4.471 22.0602 4.18978C21.779 3.90856 21.3977 3.7504 21 3.75ZM12.75 18.75V5.25H21L21.0015 18.75H12.75Z",
    fill: "#101010"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferralicon);
export default __webpack_public_path__ + "static/media/referral icon.07b113797bef9fb693bf8eee9a8c4499.svg";
export { ForwardRef as ReactComponent };